/**
 * @license
 * Copyright (c) 2018 Google Inc. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * Code distributed by Google as part of this project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
'use strict';

import AbstractDevtoolsChannel from '../runtime/debug/abstract-devtools-channel.js';

export default class ChromeExtensionChannel extends AbstractDevtoolsChannel {
  constructor() {
    super();
    this._makeReady(); // TODO: Consider readiness if connecting via extension.
  }

  _flush(messages) {
    document.dispatchEvent(new CustomEvent('arcs-debug', {detail: messages}));
  }
}



//////////////////
// WEBPACK FOOTER
// /Users/sjmiles/Sites/projects/arcs/arcs/platform/devtools-channel-web.js
// module id = 45
// module chunks = 0